const Frame1 = ({ size = 20, ...rest }) => {
  return (
    <svg
      width='48'
      height='48'
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <g clip-path='url(#clip0_3836_41965)'>
        <rect width='48' height='48' rx='24' fill='#47CD89' />
        <rect width='48' height='48' fill='white' fill-opacity='0.08' />
        <path
          d='M19.0992 36L7.69922 24.6L10.5492 21.75L19.0992 30.3L37.4492 11.95L40.2992 14.8L19.0992 36Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_3836_41965'>
          <rect width='48' height='48' rx='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Frame1
